import React from 'react'

import {
  ButtonGroup,
  Checkbox,
  Heading,
  Input,
  ModalBox,
  useMediaQueryContext,
} from '@fourthwall/components'

import * as S from './SelectModal.styled'
import type { SelectModalProps } from './types'

export const SelectModal = ({
  title,
  content,
  contentRef,
  message,
  submitDisabled,
  cancelButtonLabel = 'Cancel',
  submitButtonLabel = 'Save',
  close,
  onSubmitClick,
  inputProps = {
    disabled: true,
  },
  selectAllCheckboxProps,
}: SelectModalProps) => {
  const media = useMediaQueryContext()

  return (
    <ModalBox
      size={media.tablet ? 'large' : 'fullScreen'}
      withoutPadding
      onClose={close}
      disableScrolling
    >
      <S.Container>
        <S.TitleContainer>
          <Heading type={media.tablet ? 'h3' : 'h4'} weight="semibold">
            {title}
          </Heading>
        </S.TitleContainer>
        {!!inputProps.onValueChange && inputProps.value !== undefined && (
          <S.InputContainer>
            <Input size={media.tablet ? 'large' : 'medium'} {...inputProps} />
          </S.InputContainer>
        )}
        {selectAllCheckboxProps && (
          <S.SelectAllContainer>
            <Checkbox indeterminate {...selectAllCheckboxProps} />
          </S.SelectAllContainer>
        )}
        <S.ContentContainer id="selectModalContent" ref={contentRef}>
          {content}
        </S.ContentContainer>
      </S.Container>
      <S.Bar>
        {message && <S.Message>{message}</S.Message>}
        <ButtonGroup space="medium" direction="row" fullWidth={!media.tablet}>
          <S.Button
            label={cancelButtonLabel}
            size={media.tablet ? 'small' : 'medium'}
            onClick={close}
            fullWidth={!media.tablet}
          />
          <S.Button
            label={submitButtonLabel}
            disabled={submitDisabled}
            appearance="primary"
            size={media.tablet ? 'small' : 'medium'}
            fullWidth={!media.tablet}
            onClick={onSubmitClick}
          />
        </ButtonGroup>
      </S.Bar>
    </ModalBox>
  )
}
